
//
//-------- positioning helper function for markers --------
//

AFRAME.registerComponent('go_cam_reset', {

    init: function () {
      document.querySelector('a-scene').addEventListener('enter-vr', function () {
        document.querySelector('[camera]').object3D.position.set(0,0,0);
      });
      console.log('reset cam for Go');
      // Reload work around, Oculus Go controller stops responding after re-entering VR
      // https://github.com/aframevr/aframe/issues/3390
      document.querySelector('a-scene').addEventListener('exit-vr', function () {
        window.location.reload(true);
      });
    }
});


AFRAME.registerComponent('yhelper', {
    init: function () {
        var yDisplay = document.createElement("a-entity");
        yDisplay.setAttribute('geometry', 'primitive: plane; width: 0.7; height: 0.15;');
        yDisplay.setAttribute('material', 'shader: flat; opacity: 0.3; color: #000000');
        yDisplay.setAttribute('rotation', '0 0 0');
        yDisplay.setAttribute('position', '0 0.125 -1');
        yDisplay.setAttribute('text', 'value', 'y-pos');
        yDisplay.setAttribute('text', 'align', 'center');
        yDisplay.setAttribute('text', 'wrapCount', '20');
        this.el.appendChild(yDisplay);
        this.yDisplay = yDisplay;
        //var quaternion = this.quaternion = new THREE.Quaternion();
        //var rotation = this.rotation = new THREE.Euler();
        //let sourceEntity = this.sourceEntity = document.querySelector('[camera]');


    },
    tick: function () {   
        //let sq = this.sourceEntity.object3D.getWorldQuaternion( this.quaternion );
        //this.rotation.setFromQuaternion( this.quaternion );
        // console.log("quaternion", sq);
        // console.log("rotation", this.rotation);
        //this.yDisplay.setAttribute('text', 'value', Math.round(THREE.Math.radToDeg(this.rotation._y) * 100) / 100 );

        var _rot = this.el.getAttribute('rotation');
        var _Yrot = 'Y '+ Math.round(_rot.y * 100) / 100;
        var _Xrot = ' | X '+ Math.round(_rot.x * 100) / 100;
        this.yDisplay.setAttribute('text', 'value', _Yrot+_Xrot);
        
        //console.log(this.el.getAttribute('rotation'));


    }    
});


//////////////////
// WEBPACK FOOTER
// ./src/helpers.js
// module id = 5
// module chunks = 0